import React from 'react';

const TocPage = React.forwardRef(({ chapters, pageNumber }, ref) => {
  return (
    <div ref={ref} className="book-page">
      <div className="book-page-inner bg-white px-4 sm:px-6 py-4 overflow-hidden">
        {/* Header */}
        <div className="mb-2.5">
          <h2
            className="text-sm sm:text-base font-bold text-gray-900 uppercase tracking-tight"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            Contents
          </h2>
          <div className="w-5 h-0.5 bg-rose-700 rounded-full mt-1 mb-0.5" />
          <p
            className="text-[8px] sm:text-[9px] text-gray-400 uppercase tracking-widest"
            style={{ fontFamily: "'Space Mono', monospace" }}
          >
            {chapters.length} Chapters
          </p>
        </div>

        {/* Entries */}
        <div className="space-y-0">
          {chapters.map((chapter) => {
            const isFeatured = chapter.is_sample;
            return (
              <div
                key={chapter.index}
                className={`flex items-center py-0.5 text-[9px] sm:text-[10px] ${
                  isFeatured
                    ? 'bg-rose-50/60 -mx-1.5 px-1.5 rounded border-l-[1.5px] border-rose-600'
                    : 'opacity-45'
                }`}
              >
                <span
                  className={`w-4 shrink-0 font-bold ${
                    isFeatured ? 'text-rose-700' : 'text-gray-300'
                  }`}
                  style={{ fontFamily: "'Space Mono', monospace", fontSize: '9px' }}
                >
                  {String(chapter.index + 1).padStart(2, '0')}
                </span>
                {chapter.title_emoji && (
                  <span className="mr-0.5 text-[9px] shrink-0">{chapter.title_emoji}</span>
                )}
                <span
                  className={`truncate ${
                    isFeatured ? 'text-gray-900 font-medium' : 'text-gray-400'
                  }`}
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {chapter.title}
                </span>
                <span className="flex-1 mx-1 border-b border-dotted border-gray-200 min-w-[6px]" />
                <span
                  className={`shrink-0 text-[7px] sm:text-[8px] ${isFeatured ? 'text-gray-400' : 'text-gray-300'}`}
                  style={{ fontFamily: "'Space Mono', monospace" }}
                >
                  {chapter.date}
                </span>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="mt-2 pt-1.5 border-t border-gray-100">
          <p
            className="text-[7px] sm:text-[8px] text-gray-400 text-center"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            <span className="text-rose-600 font-semibold">Highlighted chapters</span> are included in this preview
          </p>
        </div>

        {pageNumber !== undefined && (
          <div className="book-page-number">{pageNumber}</div>
        )}
      </div>
    </div>
  );
});

TocPage.displayName = 'TocPage';
export default TocPage;
